import EventEmitter from 'events';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';
/**
* RR_PC_16
* */
class ReplenishReviewStore extends EventEmitter {
    PageLoadData = "";
    GetData = "";
    StatusUpdate = "";
    updateFavPageResponse = { updateType: 0, responseStr: "" };
    handleReplenStore = (action) => {
        switch (action.action.type) {

            case SDIConstants.methodNames.ReplenishmentReview_Pageload: {
                this.PageLoadData = action.action.response;
                this.emit('PageLoad');
                break;
            }

            case SDIConstants.methodNames.ReplenishmentReview_VendorData: {
                this.PageLoadData = action.action.response;
                this.emit('Vendor');
                break;
            }

            //CPW-97 Replenish Review -Yuvarani K

            case SDIConstants.methodNames.ReplenishmentReview_GetOtherData: {
                this.GetData = action.action.response;
                this.emit('popupData');
                break;
            }



            case SDIConstants.methodNames.ReplenishmentReview_GetData: {
                this.GetData = action.action.response;
                this.emit('GetData');
                break;
            }
            case SDIConstants.methodNames.ReplenishmentReview_GetData: {
                this.GetData = action.action.response;
                this.emit('ExportToExcel');
                break;
            }
            case SDIConstants.methodNames.ReplenishmentReview_ProcessReplen: {
                this.GetData = action.action.response;
                this.emit('ProcessReplen');
                break;
            }
            case SDIConstants.methodNames.ReplenishmentReview_UpdateItem: {
                this.GetData = action.action.response;
                this.emit('UpdateItem');
                break;
            }

            case SDIConstants.methodNames.ReplenishmentReview_UpdateItem: {
                this.StatusUpdate = action.action.response;
                this.emit('OnStatusChange');
                break;
            }
            case SDIConstants.methodNames.ProductReplen_ItemDelete: {
                this.PageLoadData = action.action.response;
                this.emit('ItemDelete');
                break;
            }
            case "NOTIFY_InsertFavPage": {

                this.updateFavPageResponse.updateType = 1;
                this.updateFavPageResponse.responseStr = action.action.response;
                this.emit('updateFavPage');
                break;
            }
            case "NOTIFY_DeleteFavPage": {
                this.updateFavPageResponse.updateType = 2;
                this.updateFavPageResponse.responseStr = action.action.response;
                this.emit('updateFavPage');
                break;
            }
            case "NOTIFY_CurrentFavPage": {
                this.currentFavPageResponse = action.action.response;
                this.emit('favpage');
                break;
            }
        }
    }
}

const objReplenStore = new ReplenishReviewStore;
// Dispatcher code
Dispatcher.register(objReplenStore.handleReplenStore.bind(objReplenStore));
export default objReplenStore;